import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import DriverService from "app/data/drivers/driversService";

export const useDriverDetails = (driverId: string) => {
  const { data: driverDetails, isLoading: isLoadingDriverDetails, refetch: refetchDriverDetails } =
    useQuery({
      queryKey: [QUERY_KEYS.DRIVER_DETAILS, driverId],
      queryFn: async () => {
        if (driverId) {
          const response = await DriverService.getInstance().getDriver(driverId);
          return response;
        }
      },
      refetchOnWindowFocus: false,
      enabled: !!driverId,
      retry: false,
    })
  return { driverDetails, isLoadingDriverDetails, refetchDriverDetails };
}